import axios from '../../../axios';

const actions = {
  async markAsDelivered({ commit }, { params, data }) {
    commit('POD_LOADING', true);
    try {
      const result = await axios.post(`/track/${params.id}/${params.trackId}`, { data });
      if (result && result.data) {
        commit('UPDATE_TRACK_DATA', result.data);
        commit('POD_LOADING', false);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('POD_LOADING', false);
    }
  },
  async submitOtp({ commit }, { params, data }) {
    commit('POD_LOADING', true);
    try {
      const result = await axios.post(`/track/${params.id}/${params.trackId}/approve_otp`, { data });
      if (result && result.data) {
        commit('UPDATE_TRACK_DATA', result.data);
        commit('POD_LOADING', false);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('POD_LOADING', false);
    }
  },

  async track({ commit }, params) {
    commit('POD_LOADING', true);
    try {
      const result = await axios.get(`/track/${params.id}/${params.trackId}`);
      if (result && result.data) {
        commit('UPDATE_TRACK_DATA', result.data);
      }
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('POD_LOADING', false);
    }
  },

  async location({ commit }, { tripId }) {
    try {
      const result = await axios(`track/location?tripId=${tripId}`);
      if (result.data) {
        commit('SET_LOCATION_DATA', result.data);
        return result.data;
      }
      return false;
    } catch (err) {
      return false;
    }
  },

};

export default actions;
